<nz-modal
    nzClassName="cb4-assignment-modal"
    [nzStyle]="{ top: '5vh' }"
    [nzVisible]="visible && !isDirectItemAction"
    [nzTitle]="modalTitleTpl"
    [nzWidth]="isExactItemMode ? 'min(1100px, calc(100vw - 24px))' : '1140px'"
    [nzBodyStyle]="isExactItemMode ? exactBodyStyle : null"
    [nzMaskClosable]="!isEmailPanelVisible"
    [nzKeyboard]="!isEmailPanelVisible"
    [nzClosable]="!isEmailPanelVisible"
    [nzFooter]="isExactItemMode ? null : modalFooterTpl"
    (nzOnCancel)="close()"
>
    <ng-container *nzModalContent>
        <ng-container *ngIf="isExactItemMode; else fullAssessmentEvidenceContent">
            <ng-container>
            <app-loading-indicator *ngIf="loading"></app-loading-indicator>
            <nz-alert *ngIf="!loading && errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
            <div class="task-browser">
                <div class="task-browser__list">
                    <app-evidence-work-item-card *ngIf="!loading && !errorMessage && currentExactItem as item"
                        [evidence]="item" [assessmentRoute]="exactAssessmentRoute"
                        (edit)="openEditEvidenceItemForm(item.id)" (delete)="openEvidenceItemDeleteConfirmation(item.id)"
                        (email)="toggleEmailPanel()" (upload)="requestEvidenceItemUploadForItem(item.id)"
                        (linkedFile)="requestExactLinkedFile($event)" (navigate)="close()">
                        <app-work-item-comments [evidence]="{ id: item.id, productLicenseId: item.productLicenseId }" [busy]="isItemMutationInProgress"></app-work-item-comments>
                    </app-evidence-work-item-card>
                </div>
            </div>
            </ng-container>
        </ng-container>
        <ng-template #fullAssessmentEvidenceContent>
        <ng-container>
            <app-loading-indicator *ngIf="loading"></app-loading-indicator>
            <nz-alert *ngIf="!loading && errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
            <nz-alert *ngIf="!loading && !errorMessage && copyErrorMessage" nzType="error" [nzMessage]="copyErrorMessage" nzShowIcon></nz-alert>
            <nz-alert *ngIf="!loading && !errorMessage && emailFailureMessage" nzType="error" [nzMessage]="emailFailureMessage" nzShowIcon></nz-alert>
            <div *ngIf="!loading && !errorMessage && (hasPersistedEvidenceItems || canManagePersistedEvidenceItems)" class="evidence-requirements-modal__selection-toolbar">
                <div class="evidence-requirements-modal__selection-actions">
                    <button
                        nz-button
                        type="button"
                        class="cb4-button"
                        nzType="default"
                        [disabled]="!hasPersistedEvidenceItems || areAllPersistedEvidenceItemsSelected"
                        (click)="selectAllEvidenceItems()"
                    >
                        Select All
                    </button>
                    <button
                        nz-button
                        type="button"
                        class="cb4-button"
                        nzType="default"
                        [disabled]="!hasSelectedEvidenceItems"
                        (click)="deselectAllEvidenceItems()"
                    >
                        Deselect All
                    </button>
                    <button *ngIf="!evidenceFiltersVisible && hasPersistedEvidenceItems" class="cb4-button" nz-button nzType="link" type="button" (click)="showEvidenceFilters()">
                        <span nz-icon nzType="search"></span> Search/Filter/Sort
                    </button>
                    <button *ngIf="canManagePersistedEvidenceItems" nz-button type="button" class="cb4-button" nzType="primary" (click)="openCreateEvidenceItemForm()">
                        <span nz-icon nzType="plus"></span>Add Evidence Requirement
                    </button>
                </div>
                <span
                    class="evidence-requirements-modal__selection-count"
                    aria-live="polite"
                    [attr.aria-label]="selectedEvidenceItemCount + ' selected across all loaded evidence items'"
                >
                    {{ selectedEvidenceItemCount }} selected
                </span>
            </div>
            <div *ngIf="!loading && !errorMessage && evidenceFiltersVisible && hasPersistedEvidenceItems" class="evidence-requirements-modal__filter">
                <div class="evidence-requirements-modal__filter-control evidence-requirements-modal__filter-control--search">
                    <input
                        id="evidence-requirements-search"
                        type="search"
                        [value]="evidenceSearchQuery"
                        (input)="updateEvidenceSearchQuery($any($event.target).value)"
                        placeholder="Search by evidence name or control number"
                        aria-label="Filter evidence items by evidence name or control"
                    />
                </div>
                <div class="evidence-requirements-modal__filter-control">
                    <nz-select
                        id="evidence-status-filter"
                        class="evidence-requirements-modal__filter-select"
                        [ngModel]="selectedStatusFilters"
                        (ngModelChange)="updateStatusFilters($event)"
                        nzMode="multiple"
                        nzShowSearch
                        nzAllowClear
                        [nzMaxTagCount]="1"
                        nzPlaceHolder="Filter by submissions status"
                    >
                        <nz-option
                            *ngFor="let status of evidenceRequirementStatuses"
                            [nzLabel]="getStatusLabel(status)"
                            [nzValue]="status"
                        ></nz-option>
                    </nz-select>
                </div>
                <div *ngIf="canManagePersistedEvidenceItems" class="evidence-requirements-modal__filter-control">
                    <nz-select
                        id="evidence-assigned-user-filter"
                        class="evidence-requirements-modal__filter-select"
                        [ngModel]="selectedAssignedUserFilters"
                        (ngModelChange)="updateAssignedUserFilters($event)"
                        nzMode="multiple"
                        nzShowSearch
                        nzAllowClear
                        [nzMaxTagCount]="1"
                        nzPlaceHolder="Filter by user assignment"
                    >
                        <nz-option
                            *ngFor="let user of assignedUserFilterOptions"
                            [nzLabel]="user.displayName"
                            [nzValue]="user.userId"
                        ></nz-option>
                    </nz-select>
                </div>
                <nz-select
                    id="evidence-requirements-sort"
                    aria-label="Sort evidence items"
                    class="evidence-requirements-modal__sort"
                    nzSize="small"
                    [ngModel]="selectedEvidenceSort"
                    (ngModelChange)="updateEvidenceSort($event)"
                    [nzCustomTemplate]="evidenceSortSelectionTpl">
                    <nz-option *ngFor="let option of evidenceSortOptions"
                        [nzValue]="option.value" [nzLabel]="option.accessibleLabel" nzCustomContent>
                        <span [attr.aria-label]="option.accessibleLabel">
                            {{ option.label }} <span nz-icon [nzType]="option.icon" aria-hidden="true"></span>
                        </span>
                    </nz-option>
                </nz-select>
                <ng-template #evidenceSortSelectionTpl let-selected>
                    <ng-container *ngFor="let option of evidenceSortOptions">
                        <span *ngIf="option.value === selected.nzValue" [attr.aria-label]="option.accessibleLabel">
                            {{ option.label }} <span nz-icon [nzType]="option.icon" aria-hidden="true"></span>
                        </span>
                    </ng-container>
                </ng-template>
                <button nz-button type="button" class="cb4-button evidence-requirements-modal__clear-filters" nzType="default" [disabled]="!evidenceSearchQuery && !activeFilterCount" (click)="clearFilters()">Clear Filters</button>
            </div>
            <p *ngIf="!loading && !errorMessage && !hasPersistedEvidenceItems" class="evidence-requirements-modal__empty">
                No evidence requirement items have been created for this assessment.
            </p>
            <section *ngIf="!loading && !errorMessage && hasFilteredEvidenceItems" class="evidence-requirements-modal__item-list" aria-label="Evidence requirement items">
                <article
                    *ngFor="let item of filteredPersistedEvidenceItems; trackBy: trackByEvidenceItemId"
                    class="evidence-requirements-modal__item-card"
                    [class.evidence-requirements-modal__item-card--selected]="isEvidenceItemSelected(item.id)"
                >
                    <label class="evidence-requirements-modal__item-select">
                        <input
                            type="checkbox"
                            [checked]="isEvidenceItemSelected(item.id)"
                            [attr.aria-label]="'Select ' + item.evidenceName"
                            (change)="toggleEvidenceItemSelection(item.id, $any($event.target).checked)"
                        />
                    </label>
                    <div class="evidence-requirements-modal__item-content">
                        <div class="evidence-requirements-modal__item-header">
                            <span class="evidence-requirements-modal__item-name">{{ item.evidenceName }}</span>
                            <nz-tag
                                class="evidence-requirements-modal__status"
                                [nzColor]="item.status === 'submitted_reviewed' ? 'success' : null"
                                [ngClass]="'evidence-requirements-modal__status--' + item.status"
                            >
                                {{ getStatusLabel(item.status) }}
                            </nz-tag>
                        </div>
                        <div class="evidence-requirements-modal__item-header">
                            <div>
                                <p *ngIf="canManagePersistedEvidenceItems" class="evidence-requirements-modal__item-detail">Assigned to: {{ getAssignedUserLabel(item) }}</p>
                                <p class="evidence-requirements-modal__item-detail">Applicable Controls: {{ getRequirementSummary(item) }}</p>
                                <p *ngIf="item.dueDate" class="evidence-requirements-modal__item-detail"
                                    [class.evidence-requirements-modal__item-detail--overdue]="evidenceDueState(item.dueDate, item.status) === 'overdue'"
                                    [class.text-danger]="evidenceDueState(item.dueDate, item.status) === 'overdue'"
                                    [class.evidence-requirements-modal__item-detail--soon]="evidenceDueState(item.dueDate, item.status) === 'due_soon'"
                                    [class.text-warning]="evidenceDueState(item.dueDate, item.status) === 'due_soon'">
                                    <span class="evidence-requirements-modal__due-label">Due:&nbsp;</span><time [attr.datetime]="item.dueDate">{{ item.dueDate | date: 'd MMMM yyyy' }}</time>
                                </p>
                                <div class="evidence-requirements-modal__linked-file" *ngIf="item.linkedSecureStorageFileId && item.linkedFileAccessible">
                                    <strong>Uploaded file:</strong> <span>{{ item.linkedFileName || 'Linked Secure Storage file' }}</span>
                                    <button nz-button type="button" class="cb4-button evidence-requirements-modal__linked-file-icon" nzType="primary" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Download linked file" (click)="requestLinkedFile(item, 'download')">
                                        <span nz-icon nzType="download"></span>
                                    </button>
                                    <button nz-button type="button" class="cb4-button evidence-requirements-modal__linked-file-icon" nzType="primary" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Preview linked file" (click)="requestLinkedFile(item, 'preview')">
                                        <span nz-icon nzType="eye"></span>
                                    </button>
                                    <button nz-button type="button" class="cb4-button evidence-requirements-modal__linked-file-icon" nzType="primary" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Manage linked file" (click)="requestLinkedFile(item, 'manage')">
                                        <span nz-icon nzType="folder-open"></span>
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="canManagePersistedEvidenceItems || canOpenEvidenceUpload" class="evidence-requirements-modal__item-actions">
                                <button *ngIf="canOpenEvidenceUpload" nz-button type="button" class="cb4-button" nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Upload Evidence" aria-label="Upload evidence" [disabled]="isItemMutationInProgress" (click)="requestEvidenceItemUploadForItem(item.id)"><span nz-icon nzType="upload"></span></button>
                                <button *ngIf="!canManagePersistedEvidenceItems && item.canEditAssigned" nz-button type="button" class="cb4-button" nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Edit" aria-label="Edit evidence" (click)="openEditEvidenceItemForm(item.id)"><span nz-icon nzType="edit"></span></button>
                                <ng-container *ngIf="canManagePersistedEvidenceItems">
                                <button nz-button type="button" class="cb4-button" nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Send Email" aria-label="Email evidence" [disabled]="isItemMutationInProgress" (click)="openEvidenceItemEmail(item)"><span nz-icon nzType="mail"></span></button>
                                <button nz-button type="button" class="cb4-button" nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Edit" aria-label="Edit evidence" [disabled]="isItemMutationInProgress" (click)="openEditEvidenceItemForm(item.id)"><span nz-icon nzType="edit"></span></button>
                                <button nz-button type="button" class="cb4-button" nzDanger nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Delete" aria-label="Delete evidence" [disabled]="isItemMutationInProgress" (click)="openEvidenceItemDeleteConfirmation(item.id)"><span nz-icon nzType="delete"></span></button>
                                </ng-container>
                            </div>
                        </div>
                        <app-work-item-comments *ngIf="productLicenseId" [evidence]="{ id: item.id, productLicenseId: productLicenseId }" [busy]="isItemMutationInProgress"></app-work-item-comments>
                    </div>
                </article>
            </section>
            <p *ngIf="!loading && !errorMessage && hasPersistedEvidenceItems && !hasFilteredEvidenceItems" class="evidence-requirements-modal__empty">
                No evidence requirements match this filter.
            </p>
        </ng-container>

        </ng-template>

    </ng-container>
</nz-modal>

<nz-modal
    nzClassName="cb4-assignment-modal"
    [nzStyle]="{ top: '5vh' }"
    [nzVisible]="visible && isEmailPanelVisible"
    nzTitle="Email List of Evidence Requirements"
    [nzWidth]="'min(840px, calc(100vw - 24px))'"
    [nzMaskClosable]="!isEmailSubmissionInProgress"
    [nzKeyboard]="!isEmailSubmissionInProgress"
    [nzClosable]="!isEmailSubmissionInProgress"
    [nzFooter]="emailFooterTpl"
    (nzOnCancel)="closeEmailModal()"
>
    <ng-container *nzModalContent>
        <section class="evidence-requirements-modal__email-view" aria-labelledby="evidence-email-heading">
            <app-loading-indicator *ngIf="isEmailSubmissionInProgress"></app-loading-indicator>
            <ng-container *ngIf="!isEmailSubmissionInProgress">
                <p id="evidence-email-heading">This action will send an email containing links for uploading the selected evidence requirements to each of the following assigned users:</p>
                <nz-alert *ngIf="emailFailureMessage" nzType="error" [nzMessage]="emailFailureMessage" nzShowIcon></nz-alert>
                <app-loading-indicator *ngIf="recipientLoading"></app-loading-indicator>
                <nz-alert *ngIf="!recipientLoading && recipientErrorMessage" nzType="error" [nzMessage]="recipientErrorMessage" nzShowIcon></nz-alert>
                <nz-alert *ngIf="!recipientLoading && !recipientErrorMessage && emailErrorMessage" nzType="error" [nzMessage]="emailErrorMessage" nzShowIcon></nz-alert>
                <p *ngIf="!recipientLoading && !recipientErrorMessage && recipientSummary && !recipientSummary.recipients.length" class="evidence-requirements-modal__empty">
                    None of the selected items has an assigned user.
                </p>
                <div *ngIf="!recipientLoading && !recipientErrorMessage && recipientSummary && recipientSummary.recipients.length" class="evidence-requirements-modal__recipient-summary">
                    <div *ngFor="let recipient of recipientSummary.recipients" class="evidence-requirements-modal__recipient-summary-item">
                        <span>{{ recipient.displayName }} ({{ recipient.role }})</span>
                        <strong>{{ recipient.selectedItemCount }} evidence item{{ recipient.selectedItemCount === 1 ? '' : 's' }}</strong>
                    </div>
                </div>
                <div class="vertical_10"></div>
                <p *ngIf="!recipientLoading && !recipientErrorMessage && recipientSummary && recipientSummary.recipients.length" class="evidence-requirements-modal__hint">
                    Upon successfully uploading a file corresponding to an evidence requirement, the item's status will be changed to "File Pending Review".
                </p>
            </ng-container>
        </section>
    </ng-container>
</nz-modal>

<nz-modal
    nzClassName="cb4-assignment-modal"
    [nzStyle]="{ top: '5vh' }"
    [nzVisible]="bulkEditModalVisible"
    nzTitle="Edit Selected Evidence Requirements"
    [nzMaskClosable]="false"
    [nzKeyboard]="!itemUserChildOpen && !itemUserReturnPending"
    [nzClosable]="!itemUserChildOpen && !itemUserReturnPending"
    [nzFooter]="bulkEditModalFooterTpl"
    (nzOnCancel)="closeBulkEditEvidenceItems()"
>
    <ng-container *nzModalContent>
        <nz-alert *ngIf="bulkEditErrorMessage" nzType="error" [nzMessage]="bulkEditErrorMessage" nzShowIcon></nz-alert>
        <div class="evidence-requirements-modal__form-field">
            <label for="bulk-evidence-item-name">Evidence name</label>
            <input
                id="bulk-evidence-item-name"
                type="text"
                [(ngModel)]="bulkEditFormState.evidenceName"
                maxlength="255"
                autocomplete="off"
                placeholder="Leave blank to keep existing names"
            />
        </div>
        <div class="evidence-requirements-modal__form-field">
            <label for="bulk-evidence-item-status">Submission Status</label>
            <nz-select id="bulk-evidence-item-status" [(ngModel)]="bulkEditFormState.status">
                <nz-option nzLabel="Leave unchanged" [nzValue]="null"></nz-option>
                <nz-option
                    *ngFor="let status of evidenceRequirementStatuses"
                    [nzLabel]="getStatusLabel(status)"
                    [nzValue]="status"
                ></nz-option>
            </nz-select>
        </div>
        <div class="evidence-requirements-modal__form-field">
            <label for="bulk-evidence-item-due-date-mode">Due date</label>
            <nz-select
                id="bulk-evidence-item-due-date-mode"
                [ngModel]="bulkEditFormState.dueDateMode"
                (ngModelChange)="setBulkDueDateMode($event)"
            >
                <nz-option nzLabel="Leave unchanged" nzValue="unchanged"></nz-option>
                <nz-option nzLabel="Set date" nzValue="set"></nz-option>
                <nz-option nzLabel="Clear date" nzValue="clear"></nz-option>
            </nz-select>
            <ng-container *ngIf="bulkEditFormState.dueDateMode === 'set'">
                <label for="bulk-evidence-item-due-date">New due date</label>
                <nz-date-picker
                    id="bulk-evidence-item-due-date"
                    class="evidence-requirements-modal__date-picker"
                    nzFormat="d MMMM yyyy"
                    nzPlaceHolder="Select due date"
                    [nzAllowClear]="true"
                    [nzDisabledDate]="bulkDueDateDisabled"
                    [ngModel]="bulkDueDatePickerValue"
                    (ngModelChange)="setBulkDueDate($event)"
                ></nz-date-picker>
                <span
                    *ngIf="bulkDueDateTouched && !isAllowedBulkDueDate"
                    class="evidence-requirements-modal__form-error"
                    role="alert"
                >Choose a valid future date.</span>
            </ng-container>
        </div>
        <div class="evidence-requirements-modal__form-field">
            <label for="bulk-evidence-item-requirement-mode">Applicable Controls</label>
            <nz-select
                id="bulk-evidence-item-requirement-mode"
                [ngModel]="bulkEditFormState.requirementSelectionMode"
                (ngModelChange)="setBulkRequirementSelectionMode($event)"
            >
                <nz-option nzLabel="Leave unchanged" nzValue="unchanged"></nz-option>
                <nz-option nzLabel="All controls" nzValue="all"></nz-option>
                <nz-option nzLabel="Replace with specific controls" nzValue="specific"></nz-option>
            </nz-select>
            <nz-select
                id="bulk-evidence-item-requirements"
                [(ngModel)]="bulkEditFormState.requirementKeys"
                nzMode="multiple"
                nzShowSearch
                nzAllowClear
                [nzDisabled]="!isBulkSpecificRequirementSelectionEnabled"
                nzPlaceHolder="Search current in-scope requirements"
            >
                <nz-option
                    *ngFor="let requirementKey of requirementOptions"
                    [nzLabel]="requirementKey"
                    [nzValue]="requirementKey"
                ></nz-option>
            </nz-select>
        </div>
        <div #bulkEvidenceOrigin class="evidence-requirements-modal__form-field">
            <label for="bulk-evidence-item-assignment-mode">Assigned user(s)</label>
            <nz-select
                id="bulk-evidence-item-assignment-mode"
                [ngModel]="bulkEditFormState.assignmentSelectionMode"
                (ngModelChange)="setBulkAssignmentSelectionMode($event)"
            >
                <nz-option nzLabel="Leave unchanged" nzValue="unchanged"></nz-option>
                <nz-option nzLabel="Unassigned / None" nzValue="unassigned"></nz-option>
                <nz-option nzLabel="Replace with selected users" nzValue="specific"></nz-option>
            </nz-select>
            <nz-select
                #bulkEvidenceAssignees
                id="bulk-evidence-item-assignees"
                aria-describedby="bulk-evidence-assignees-hint"
                [nzDropdownRender]="bulkEvidenceAddUserDropdown"
                class="evidence-requirements-modal__bulk-assignee-select"
                [(ngModel)]="bulkEditFormState.assignedUserIds"
                nzMode="multiple"
                nzShowSearch
                nzAllowClear
                [nzDisabled]="!isBulkSpecificAssigneeSelectionEnabled || itemUserChildOpen || itemUserReturnPending"
                nzPlaceHolder="Search eligible users"
            >
                <nz-option
                    *ngFor="let user of uploaderOptions"
                    [nzLabel]="getEvidenceUploadUserLabel(user) + ' - ' + user.role"
                    [nzValue]="user.userId"
                ></nz-option>
            </nz-select>
            <ng-template #bulkEvidenceAddUserDropdown>
                <div *ngIf="itemUserInviteAllowed" class="evidence-requirements-modal__dropdown-action"
                    (mousedown)="$event.preventDefault(); $event.stopPropagation()">
                    <button nz-button nzType="primary" class="cb4-button" type="button"
                        [disabled]="!canAddBulkEvidenceUser" (click)="openAssessmentAssignments($event)">
                        <i nz-icon nzType="team"></i> Edit Assessment Assignees
                    </button>
                    <button nz-button nzType="primary" class="cb4-button" type="button"
                        [disabled]="!canAddBulkEvidenceUser" (click)="openAddBulkEvidenceUser($event)">
                        <i nz-icon nzType="user-add"></i> Add New User
                    </button>
                </div>
            </ng-template>
            <p id="bulk-evidence-assignees-hint" class="evidence-requirements-modal__assignee-hint">
                Note - only users <button class="evidence-requirements-modal__assignee-link" type="button" (click)="openAssessmentAssignments()">already assigned</button> to this assessment can be assigned to a task.
            </p>
        </div>
    </ng-container>
</nz-modal>

<nz-modal
    nzClassName="cb4-assignment-modal"
    [nzStyle]="{ top: '5vh' }"
    [nzVisible]="itemFormModalVisible"
    [nzTitle]="itemFormMode === 'create' ? 'Add Evidence Requirement' : 'Edit Evidence Requirement'"
    [nzMaskClosable]="false"
    [nzKeyboard]="!itemUserChildOpen && !itemUserReturnPending"
    [nzClosable]="!itemUserChildOpen && !itemUserReturnPending"
    [nzFooter]="itemFormModalFooterTpl"
    (nzOnCancel)="closeEvidenceItemForm()"
>
    <ng-container *nzModalContent>
        <nz-alert *ngIf="itemFormErrorMessage" nzType="error" [nzMessage]="itemFormErrorMessage" nzShowIcon></nz-alert>
        <div *ngIf="!limitedEvidenceEdit" #evidenceItemOrigin class="evidence-requirements-modal__form-field">
            <label for="evidence-item-name">Evidence name <span aria-hidden="true">*</span></label>
            <input
                id="evidence-item-name" [disabled]="limitedEvidenceEdit"
                type="text"
                [ngModel]="itemFormState.evidenceName"
                (ngModelChange)="setEvidenceItemName($event)"
                maxlength="255"
                required
                autocomplete="off"
            />
        </div>
        <div class="evidence-requirements-modal__form-field">
            <label for="evidence-item-status">Submission Status <span aria-hidden="true">*</span></label>
            <nz-select
                id="evidence-item-status"
                [ngModel]="itemFormState.status"
                (ngModelChange)="setEvidenceItemStatus($event)"
            >
                <nz-option
                    *ngFor="let status of evidenceRequirementStatuses"
                    [nzLabel]="getStatusLabel(status)"
                    [nzValue]="status"
                ></nz-option>
            </nz-select>
        </div>
        <div *ngIf="!limitedEvidenceEdit" class="evidence-requirements-modal__form-field">
            <label for="evidence-item-due-date">Due date</label>
            <nz-date-picker
                id="evidence-item-due-date" [nzDisabled]="limitedEvidenceEdit"
                class="evidence-requirements-modal__date-picker"
                nzFormat="d MMMM yyyy"
                nzPlaceHolder="Select due date"
                [nzAllowClear]="true"
                [nzDisabledDate]="itemDueDateDisabled"
                [ngModel]="itemDueDatePickerValue"
                (ngModelChange)="setEvidenceItemDueDate($event)"
            ></nz-date-picker>
            <span
                *ngIf="itemDueDateTouched && !isAllowedEvidenceItemDueDate"
                class="evidence-requirements-modal__form-error"
                role="alert"
            >Choose a valid future date.</span>
        </div>
        <div *ngIf="!limitedEvidenceEdit" class="evidence-requirements-modal__form-field">
            <label for="evidence-item-assignees">Assigned user(s)</label>
            <nz-select
                #evidenceItemAssignees
                id="evidence-item-assignees" [nzDisabled]="limitedEvidenceEdit"
                aria-describedby="evidence-item-assignees-hint"
                [(nzOpen)]="itemAssigneeDropdownOpen"
                [nzDropdownRender]="evidenceItemAddUserDropdown"
                class="evidence-requirements-modal__item-form-select"
                [ngModel]="itemFormState.assignedUserIds"
                (ngModelChange)="setEvidenceItemAssignedUserIds($event)"
                nzMode="multiple"
                nzShowSearch
                nzAllowClear
                [nzMaxTagCount]="1"
                nzPlaceHolder="No user assignment"
            >
                <nz-option
                    *ngFor="let user of uploaderOptions"
                    [nzLabel]="getEvidenceUploadUserLabel(user)"
                    [nzValue]="user.userId"
                ></nz-option>
            </nz-select>
            <ng-template #evidenceItemAddUserDropdown>
                <div *ngIf="itemUserInviteAllowed" class="evidence-requirements-modal__dropdown-action"
                    (mousedown)="$event.preventDefault(); $event.stopPropagation()">
                    <button nz-button nzType="primary" class="cb4-button" type="button"
                        [disabled]="!canAddEvidenceItemUser" (click)="openAssessmentAssignments($event)">
                        <i nz-icon nzType="team"></i> Edit Assessment Assignees
                    </button>
                    <button nz-button nzType="primary" class="cb4-button" type="button"
                        [disabled]="!canAddEvidenceItemUser" (click)="openAddEvidenceItemUser($event)">
                        <i nz-icon nzType="user"></i> Add New User
                    </button>
                </div>
            </ng-template>
            <p id="evidence-item-assignees-hint" class="evidence-requirements-modal__assignee-hint">
                Note - only users <button class="evidence-requirements-modal__assignee-link" type="button" (click)="openAssessmentAssignments()">already assigned</button> to this assessment can be assigned to a task.
            </p>
        </div>
        <div *ngIf="!limitedEvidenceEdit" class="evidence-requirements-modal__form-field">
            <fieldset class="evidence-requirements-modal__control-scope" [disabled]="limitedEvidenceEdit">
                <legend>Applicable Controls:</legend>
                <div class="evidence-requirements-modal__control-scope-options">
                    <label class="evidence-requirements-modal__choice">
                        <input
                            type="radio"
                            name="evidence-item-control-scope"
                            [checked]="itemFormState.allRequirements"
                            (change)="setAllRequirements(true)"
                        />
                        <span>All Controls</span>
                    </label>
                    <label class="evidence-requirements-modal__choice">
                        <input
                            type="radio"
                            name="evidence-item-control-scope"
                            [checked]="isSpecificRequirementSelectionEnabled"
                            (change)="setAllRequirements(false)"
                        />
                        <span>Specific Controls</span>
                    </label>
                </div>
            </fieldset>
            <nz-select
                *ngIf="isSpecificRequirementSelectionEnabled"
                id="evidence-item-requirements" [nzDisabled]="limitedEvidenceEdit"
                class="evidence-requirements-modal__item-form-select"
                [ngModel]="itemFormState.requirementKeys"
                (ngModelChange)="setEvidenceItemRequirementKeys($event)"
                nzMode="multiple"
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Search current in-scope requirements"
                aria-label="Specific controls"
            >
                <nz-option
                    *ngFor="let requirementKey of requirementOptions"
                    [nzLabel]="requirementKey"
                    [nzValue]="requirementKey"
                ></nz-option>
            </nz-select>
        </div>
        <div class="evidence-requirements-modal__file-row">
            <div class="evidence-requirements-modal__form-field">
                <label for="evidence-item-submitted-file">Uploaded Evidence File</label>
                <nz-select
                    id="evidence-item-submitted-file"
                    class="evidence-requirements-modal__item-form-select"
                    [ngModel]="itemFormState.linkedSecureStorageFileId"
                    (ngModelChange)="setEvidenceItemLinkedSecureStorageFileId($event)"
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Leave blank if not yet uploaded"
                >
                    <nz-option
                        *ngFor="let file of secureStorageFileOptions"
                        [nzLabel]="file.fileName"
                        [nzValue]="file.id"
                    ></nz-option>
                </nz-select>
            </div>
            <button
                *ngIf="itemFormMode === 'edit'"
                nz-button
                type="button"
                nzType="primary"
                class="cb4-button"
                nzType="default"
                [disabled]="!canUploadEvidenceItemForm"
                (click)="requestEvidenceItemUpload()"
            >
                <span nz-icon nzType="upload"></span>Upload
            </button>
        </div>
    </ng-container>
</nz-modal>

<nz-modal
    [nzVisible]="deleteConfirmationModalVisible"
    nzTitle="Delete Evidence Requirement"
    [nzMaskClosable]="false"
    [nzFooter]="deleteConfirmationModalFooterTpl"
    (nzOnCancel)="closeEvidenceItemDeleteConfirmation()"
>
    <ng-container *nzModalContent>
        <nz-alert *ngIf="deleteConfirmationErrorMessage" nzType="error" [nzMessage]="deleteConfirmationErrorMessage" nzShowIcon></nz-alert>
        <p>Delete <strong>{{ itemPendingDeletion?.evidenceName }}</strong> from this assessment?</p>
        <p>The linked Secure Storage file, if any, will remain available and will not be deleted.</p>
    </ng-container>
</nz-modal>

<ng-template #modalTitleTpl>
    {{ title }}
</ng-template>

<ng-template #modalFooterTpl>
        <div class="evidence-requirements-modal__footer">
            <div class="evidence-requirements-modal__footer-actions">
                <button *ngIf="canManagePersistedEvidenceItems" nz-button type="button" class="cb4-button" nzType="primary" [disabled]="!hasSelectedEvidenceItems" (click)="openBulkEditEvidenceItems()"><span nz-icon nzType="edit"></span>Edit Selected</button>
                <button nz-button type="button" class="cb4-button" nzType="primary" [disabled]="!hasSelectedEvidenceItems" (click)="copySelectedEvidenceItems()"><span nz-icon nzType="copy"></span>Copy Selected</button>
                <button nz-button type="button" class="cb4-button" nzType="primary" [disabled]="!hasSelectedEvidenceItems" (click)="downloadSelectedEvidenceItems()"><span nz-icon nzType="download"></span>Download Selected</button>
                <button *ngIf="canManagePersistedEvidenceItems" nz-button type="button" class="cb4-button" nzType="primary" [disabled]="!hasSelectedEvidenceItems" (click)="toggleEmailPanel()"><span nz-icon nzType="mail"></span>Email Selected</button>
            </div>
            <button nz-button type="button" class="cb4-button evidence-requirements-modal__footer-cancel" nzType="default" (click)="close()">Cancel</button>
        </div>
</ng-template>

<ng-template #itemFormModalFooterTpl>
    <button nz-button type="button" class="cb4-button" nzType="default" [disabled]="isItemMutationInProgress || itemUserChildOpen || itemUserReturnPending" (click)="closeEvidenceItemForm()">Cancel</button>
    <button
        nz-button
        type="button"
        class="cb4-button"
        nzType="primary"
        [disabled]="!isEvidenceItemFormValid || isItemMutationInProgress || exactDraftStale"
        [nzLoading]="isItemMutationInProgress"
        (click)="saveEvidenceItemForm()"
    >
        <span nz-icon [nzType]="itemFormMode === 'create' ? 'plus' : 'save'"></span>
        {{ itemFormMode === "create" ? "Add Evidence Requirement" : "Save Changes" }}
    </button>
</ng-template>

<ng-template #deleteConfirmationModalFooterTpl>
    <button nz-button type="button" class="cb4-button" nzType="default" [disabled]="isItemMutationInProgress" (click)="closeEvidenceItemDeleteConfirmation()">Cancel</button>
    <button
        nz-button
        type="button"
        class="cb4-button"
        nzDanger
        nzType="primary"
        [disabled]="exactDraftStale"
        [nzLoading]="isItemMutationInProgress"
        (click)="confirmEvidenceItemDeletion()"
    >
        <span nz-icon nzType="delete"></span>Delete Evidence Requirement
    </button>
</ng-template>

<ng-template #bulkEditModalFooterTpl>
    <button nz-button type="button" class="cb4-button" nzType="default" [disabled]="isItemMutationInProgress" (click)="closeBulkEditEvidenceItems()">Cancel</button>
    <button
        nz-button
        type="button"
        class="cb4-button"
        nzType="primary"
        [disabled]="!isBulkEditFormValid || isItemMutationInProgress"
        [nzLoading]="isItemMutationInProgress"
        (click)="saveBulkEvidenceItemEdits()"
    >
        <span nz-icon nzType="save"></span>Save Changes
    </button>
</ng-template>

<ng-template #emailFooterTpl>
    <button nz-button type="button" class="cb4-button" nzType="primary" [disabled]="!canRequestEmail" [nzLoading]="isEmailSubmissionInProgress" (click)="requestEmail()">
        <i nz-icon nzType="mail"></i> {{ isEmailSubmissionInProgress ? "Sending Email" : "Send Email" }}
    </button>
</ng-template>
